import {
  SET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
  SET_EXIM_CARGO_TEMPLATE,
  SET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
  SET_UPLOAD_SHIPMENT_DETAILS_LIST,
} from "Constants/actionConstants";

const initialState = {
  eximCargoTemplateFileUrl: "",
  eximContainerBlTrackingDetailsTemplateFileUrl: "",
  uploadShipmentDetailsList: [],
  inprogressShipmentDetailsList: [],
  completedShipmentDetailsList: [],
  sourcePortList: [],
  destinationPortList: [],
  statusList: [],
};

const EXIMCargoTracking = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_EXIM_CARGO_TEMPLATE: {
      return {
        ...state,
        eximCargoTemplateFileUrl: payload,
      };
    }
    case SET_UPLOAD_SHIPMENT_DETAILS_LIST: {
      if (payload.type === 1) {
        return {
          ...state,
          uploadShipmentDetailsList: payload.payload,
          trackingCount: payload.trackingCount
        };
      } else if (payload.type === 2) {
        return {
          ...state,
          inprogressShipmentDetailsList: payload.payload,
          trackingCount: payload.trackingCount
        };
      } else if (payload.type === 3) {
        return {
          ...state,
          completedShipmentDetailsList: payload.payload,
          trackingCount: payload.trackingCount
        };
      }
    }
    case SET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS: {
      return {
        ...state,
        sourcePortList: payload.sourcePortList,
        destinationPortList: payload.destinationPortList,
        statusList: payload.statusList,
        blNumbers: payload.blNumbers,
        categoryList: payload.categoryList
      };
    }
    case SET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE: {
      return {
        ...state,
        eximContainerBlTrackingDetailsTemplateFileUrl: payload,
      };
    }

    default:
      return state;
  }
};

export default EXIMCargoTracking;
